/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import React, { Component } from 'react';
import { Form, Button, Container, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';

// project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { mobileNumberFormat, ArrayValueReorder, commonMobileNumberFormat } from 'shared/modifiers';
import { locationlist, rolelist, selleradd, sellerdetail, sellerupdate } from 'shared/settings/apiconfig';
import Validators from 'shared/validators';
// import toast from 'shared/toast';
import { ToasterMessage } from 'shared/toast/toast';

// style imports
import './StaffAgentsEdit.scss';
import { NoData } from 'features/components/redirect/NoData';

/**
 * Staff & Agents Edit Page
 * 
 * @param StaffAgentId
 * 
 * @return html code for Staff & Agents Form
 * 
**/

class StaffAgentsEdit extends Component {
    staffAgentId;
    locationId;
    edit;
    countryCodeList;

    constructor(props) {
        super(props);
        /* check for user updation or creation edit access*/
        this.edit = false;
        this.staffAgentId = this.props.match.params['staffAgentId'];
        this.locationId = this.props.match.params['locationId'];
        if (isNaN(Number(this.staffAgentId)) && isNaN(Number(this.locationId))) {
            this.edit = true;
        }
        this.state = {
            editAccess: true,
            userid: this.edit ? null : Number(this.staffAgentId),
            locationid: this.edit ? null : Number(this.locationId),
            form: {
                locationid: { value: '', error: '', valid: false, validators: [Validators.required()] },
                firstname: { value: '', error: '', valid: false, validators: [Validators.required(), Validators.maxLength(45)] },
                lastname: { value: '', error: '', valid: false, validators: [Validators.required(), Validators.maxLength(45)] },
                email: { value: '', error: '', valid: false, validators: [Validators.required(), Validators.email()] },
                retypeEmail: { value: '', error: '', valid: false, validators: [Validators.required()] },
                mobile: { code: '+1', value: '', error: '', valid: false, validators: [Validators.required(), Validators.mobile()] },
                roleid: { value: '', error: '', valid: false, validators: [Validators.required()] },
                active: { value: '', error: '', valid: this.edit ? true : false, validators: [Validators.required()] },
            },
            errorpageredirect: false,
            locations: [],
            role: [],
            formValid: false,
            formLoading: true,
            userRole: null,
            loading: false,
            staffStatus: { show: false, type: '', message: '' },
            errorType: ''
        };
        this.countryCodeList = [{ id: 1, value: '+1' }, { id: 2, value: '+91' }];
        this.approveBack = false;
    }

    componentDidMount() {
        this.getUserData();
        this.getLocationList();
        this.getRoleList();
        if (!this.edit) {
            this.getStaffAgentData();
        }
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
    }

    onBack = (e) => {
        e.preventDefault();
        if (this.approveBack) {
            window.removeEventListener('popstate', this.onBackButtonEvent);
        } else {
            this.approveBack = true;
            this.navigateToList();
            // this.props.history.goBack();
        }
    }


    /* Get Location list */
    getLocationList = () => {
        axios.post(getSellerUrl(locationlist), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders())
            .then(response => {
                if (response.data.data.length) {
                    this.setState({
                        ...this.state,
                        locations: ArrayValueReorder(response.data.data, 'title'),
                        form: {
                            ...this.state.form,
                            locationid: {
                                ...this.state.form.locationid,
                                value: response.data.data.length === 1 ? response.data.data[0]['id'] : this.state.form.locationid.value,
                                error: '',
                                valid: response.data.data.length === 1 ? true : this.state.form.locationid.value
                            }
                        }
                    });
                }
                else {
                    this.setState({
                        ...this.state,
                        locations: [],
                        detail: {
                            ...this.state.detail,
                            locationid: {
                                ...this.state.detail.locationid,
                                error: 'You need to be an Admin to create Staff'
                            }

                        }
                    });
                }
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                if(error.response.status == 401 || error.response.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                } else {
                    this.setState({
                        ...this.state,
                        staffStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                    });
                }            
            });
    }

    /* Get user role list */
    getRoleList = () => {
        axios.post(getSellerUrl(rolelist), JSON.stringify({ field: ['id', 'name'] }), getSellerHeaders())
            .then(response => {
                this.setState({
                    ...this.state,
                    role: ArrayValueReorder(response.data.data, 'name'),
                    formLoading: false
                });
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                if(error.response.status == 401 || error.response.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                } else { 
                    this.setState({
                        ...this.state,
                        formLoading: false,
                        staffStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                    });
                }
            })
    }

    getUserData = async () => {
        /* get user details */
        await axios.post(getSellerUrl(`${sellerdetail}/${this.props.user.id}`), JSON.stringify({ field: ['id', 'role', 'roleid'] }), getSellerHeaders())
            .then(response => {
                let role = null;
                response.data.data.forEach(user => {
                    if (user['role'] === 'Administrator') {
                        role = user['role'];
                    }
                })

                this.setState({
                    ...this.state,
                    userRole: role,
                    formLoading: false,
                });
            })
            .catch((error) => {
                // toast.error(error.response.data['message']);
                if(error.response.status == 401 || error.response.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                } else {
                    this.setState({
                        ...this.state,
                        formLoading: false,
                        staffStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                    });
                }   
            });

    }

    /* Get user data initialy */
    getStaffAgentData = async () => {
        let formData = {};
        if (!this.edit) {
            const body = {
                filter: [{
                    field: 'locationid',
                    value: this.state.locationid,
                    op: '=',
                    join: 'AND'
                }]
            };

            /* get user details */
            await axios.post(getSellerUrl(`${sellerdetail}/${this.state.userid}`), body, getSellerHeaders())
                .then(response => {
                    if (response.status === 200) {
                        formData = response.data.data[0];
                        this.setState({
                            ...this.state,
                            form: {
                                ...this.state.form,
                                locationid: { ...this.state.form.locationid, valid: true, value: formData.locationid },
                                firstname: { ...this.state.form.firstname, valid: true, value: formData.firstname },
                                lastname: { ...this.state.form.lastname, value: formData.lastname, valid: true },
                                email: { ...this.state.form.email, value: formData.email, valid: true },
                                mobile: { ...this.state.form.mobile, value: this.mobileValue(formData.mobile), code: this.findCountryCode(formData.mobile), valid: true },
                                roleid: { ...this.state.form.roleid, value: formData.roleid, valid: true },
                                active: { ...this.state.form.active, value: formData.active, valid: true }
                            },
                            formLoading: false,
                            formValid: true
                        });
                    }
                })
                .catch((error) => {
                    // toast.error(error.response.data['message']);
                    if(error.response.status == 401 || error.response.status == 404) {
                        this.setState({
                            errorpageredirect: true,
                            errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                        })
                    }
                    this.setState({
                        ...this.state,
                        formLoading: false,
                        // staffStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                    });
                });

        }
        else {
            this.setState({ editAccess: true });
        }
    }

    /* find mobile number */
    mobileValue = (mobileNumber) => {
        if (!mobileNumber)
            return ''
        else if (mobileNumber[0] === '+' && mobileNumber[1] === '9')
            return mobileNumberFormat(mobileNumber.substring(3));
        else if (mobileNumber[0] === '+' && mobileNumber[1] === '1')
            return mobileNumberFormat(mobileNumber.substring(2));
        else
            return mobileNumberFormat(mobileNumber);
    }
    /* detect country code of mobile number */
    findCountryCode = (mobileNumber) => {
        const mobile = this.mobileValue(mobileNumber)
        var IndNum = /^[0]?[789]\d{9}$/;
        return IndNum.test(mobile) ? '+91' : '+1';
    }

    /* check validation for input changes*/
    inputChange = (event) => {
        let inputError = '';
        let eventValue = event.target.value;
        /* validation */
        if (event.target.name !== 'mobileCountryCode') {
            if (event.target.name === 'mobile') {
                eventValue = commonMobileNumberFormat(eventValue, this.state.form.mobile.value);
            }

            for (let validator of this.state.form[event.target.name].validators) {
                inputError = validator(eventValue);
                if (inputError) break;
            }
            /* email match validation */
            if (event.target.name === 'retypeEmail') {
                if(eventValue == ""){
                    inputError = 'Please enter value';
                }
                else if(this.state.form.email.value !== eventValue) {
                    inputError = 'Email addresses do not match above';
                }
            }

            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    [event.target.name]: {
                        ...this.state.form[event.target.name],
                        value: eventValue,
                        error: inputError,
                        valid: !Boolean(inputError)
                    }
                }
            }, () => {
                if (event.target.name === 'email' && this.edit) {
                    this.checkRetypeEmailValidity(eventValue);
                }

                /* check for form validation */
                if (inputError)
                    this.setState({
                        ...this.state,
                        formValid: false
                    });
                else {
                    this.checkFormValidity();
                }
            });
        }
        else {
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    mobile: {
                        ...this.state.form.mobile,
                        code: eventValue
                    }
                }
            });
        }
    }

    checkFormValidity = () => {
        let valid = true;
        for (let control of Object.keys(this.state.form)) {
            if (this.edit) {
                if (!this.state.form[control].valid) {
                    valid = false;
                    break;
                }
            }
            else {
                if (!this.state.form[control].valid && control !== 'retypeEmail') {
                    valid = false;
                    break;
                }
            }
        }
        let formError = this.state.staffStatus.message;
        if (valid)
            formError = this.state.staffStatus.message === 'Cannot save: please add the required fields in red above' ? '' : this.state.staffStatus.message;
        this.setState({
            ...this.state,
            formValid: valid,
            staffStatus: {
                ...this.state.staffStatus,
                message: formError
            }
        });
    }

    checkRetypeEmailValidity = (eventValue) => {
        let error = this.state.form.retypeEmail.error;
        let valid = this.state.form.retypeEmail.valid;
        let value = this.state.form.retypeEmail.value;
       
        if (this.state.form.retypeEmail.value && this.state.form.retypeEmail.value !== eventValue) {
            error = 'Email addresses do not match above';
            valid = false;
        }
        else if (this.state.form.retypeEmail.value && this.state.form.retypeEmail.value === eventValue) {
            error = '';
            valid = true;
        }
        setTimeout(() => {
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    retypeEmail: {
                        ...this.state.form.retypeEmail,
                        error: error,
                        valid: valid
                    }
                }
            }, () => this.checkFormValidity());
        });
    }

    /* called when save button clicked */
    checkFieldValidation = () => {
        let valid = true;
        let inputError = '';
        let stateData = this.state.form;
        let ignoreFields = ['active']
        let retypemail = 'retypeEmail'
        if(this.edit) {
             this.checkRetypeEmailValidity(this.state.form.email.value)
        }
        for (let control of Object.keys(stateData)) {
            if (this.edit && !ignoreFields.includes(control)) {
                for (let validator of stateData[control].validators) {
                    inputError = validator(stateData[control].value);
                    if (inputError) {
                        valid = false;
                        break;
                    }
                    if(this.edit && !stateData[retypemail].valid) {
                        valid = false;
                        break;
                    }
                }
            }
                stateData[control]['error'] = inputError;
        }
        this.setState({
            ...this.state,
            formValid: valid,
            form: stateData,
            staffStatus: { show: !valid, type: !valid ? 'danger' : '', message: !valid ? 'Cannot save: please add the required fields in red above' : '' }
        }, () => {
            if (this.state.formValid)
                this.submit()
        })

    }

    /* called after checking form validity clicked */
    submit = () => {
        try{
        if (this.state.formValid && this.state.editAccess) {
            const data = {};
            this.setState({ loading: true });
            Object.entries(this.state.form).forEach(([key, value]) => data[key] = value['value']);
            /* default value for payload */
            delete data['retypeEmail'];
            data['active'] = data['active'] ? Number(data['active']) : '';
            if (this.edit)
                delete data['active'];
            data['mobile'] = this.state.form.mobile.value;
            data['timezone'] = null;
            data['roleid'] = Number(data['roleid']);
            data['locationid'] = Number(data['locationid']);
            /* update user details */
            if (!this.edit) {
                data['id'] = this.state.userid;
                delete data['email'];
                axios.put(getSellerUrl(sellerupdate), JSON.stringify({ data: data }), getSellerHeaders())
                    .then(response => {
                        if (response.data.status === 'success') {
                            this.setState({
                                loading: false,
                                staffStatus: { show: true, type: 'success', message: 'Saved' }
                            }, () => {
                                setTimeout(() => {
                                    this.setState({
                                        loading: false,
                                        staffStatus: { show: false, type: '', message: '' }
                                    });
                                    // this.props.history.push({ pathname: '/locations/staff-agents', state: this.props.location.state });
                                }, 3000);
                            }
                            );
                            // toast.success('Successful');

                        }
                    })
                    .catch(error => {
                        this.setState({
                            loading: false,
                            staffStatus: { show: true, type: 'danger', message: error.response.data['message'][0]['message'] }
                        });

                        // toast.error(error.response.data['message'][0]['message']);
                    })
            }
            /* create new user */
            else {
                axios.post(getSellerUrl(selleradd), JSON.stringify({ data: data }), getSellerHeaders())
                    .then(response => {
                        if (response.data.status === 'success') {
                            this.setState({
                                loading: false,
                                staffStatus: { show: true, type: 'success', message: 'Saved' }
                            }
                            , () => {
                                setTimeout(() => {
                                    this.setState({
                                        loading: false,
                                        staffStatus: { show: false, type: 'success', message: '' }
                                    });
                                    // this.props.history.push({ pathname: '/locations/staff-agents', state: this.props.location.state });
                                }, 3000);
                            }
                            );
                        }
                    })
                    .catch(error => {
                        this.setState({
                            loading: false,
                            staffStatus: { show: true, type: 'danger', message: error.response.data['message'] instanceof Array ? error.response.data['message'][0]['message'] : error.response.data['message'] }
                        });
                        // error.response.data['message'] instanceof Array ? toast.error(error.response.data['message'][0]['message']) : toast.error(error.response.data['message']);
                    })
            }
        }
        }catch(e){     
            console.clear() 
        }
    }

    navigateToList = () => {
        this.props.history.push({ pathname: '/locations/staff-agents', state: this.props.location.state });
    };

    render() {
        if (this.state.errorpageredirect) {
            // redirect to Not-Found if wrong staff&agentid
            return <NoData {...this.props} type={this.state.errorType} />
        }
        return (
            <div style={{ overflow: "auto", overflowY: "overlay" }}>
                <div id="backbutton" style={{ borderBottom: "1px solid #b6b6b6", padding: "1%" }}>
                    <span className="clickable" onClick={this.navigateToList}>
                        <i className="fa fa-chevron-circle-left fa-lg text-back rounded-circle"></i>
                        <span style={{ paddingLeft: "1em" }}>Back</span>
                    </span>
                    <span style={{ marginLeft: "0.5em", paddingLeft: "1em", borderLeft: "1px solid", color: "#A12142" }}> {this.edit && 'Create New'} Staff & Agent {!this.edit && 'Edit'}</span>
                </div>
                {this.state.formLoading ?
                    <div className="d-flex flex-column align-items-center justify-content-center w-100" style={{ padding: "20%" }}>
                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                    </div> :
                    <div style={{ backgroundColor: "#BBC7D6", padding: "1%" }}>
                        <Container className="staff-agents">

                            <div>
                                <fieldset className="staff-agents-container" disabled={this.state.editAccess ? false : true}>
                                <Form id="mobile-form" style={{ padding: "4%",marginLeft:'17px', marginTop: "20px" }}>
                                         <div className="d-flex">
                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.form.locationid.error && this.state.form.locationid.error.length ? <small className="error">{this.state.form.locationid.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control as="select" id="locationid" name="locationid" value={this.state.form.locationid.value} placeholder=" " className={this.state.form.locationid.value ? 'form-control-active' : ''} required onChange={(event) => this.inputChange(event)} disabled={this.edit ? false : true}>
                                                    <option disabled={true} value={""} selected> Select Locations</option>
                                                    {this.state.locations.map((loc, index) =>
                                                        <option key={index} value={loc.id}>{loc.title}</option>
                                                    )}
                                                </Form.Control>
                                                <label htmlFor="locationid" className="required">Location</label>
                                            </div>
                                        </div>
                                        <div className="d-flex">
                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.form.firstname.error && this.state.form.firstname.error.length ? <small className="error">{this.state.form.firstname.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control type="text" id="firstname" name="firstname" value={this.state.form.firstname.value} className={this.state.form.firstname.value ? 'form-control-active' : ''} placeholder=" " onChange={(event) => this.inputChange(event)} disabled={this.edit ? false : true} />
                                                <label htmlFor="firstname" className="required">First Name</label>
                                            </div>
                                        </div>
                                        <div className="d-flex">
                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.form.lastname.error && this.state.form.lastname.error.length ? <small className="error">{this.state.form.lastname.error}</small> : null
                                                    }
                                                </div>

                                                <Form.Control type="text" id="lastname" name="lastname" value={this.state.form.lastname.value} className={this.state.form.lastname.value ? 'form-control-active' : ''} placeholder=" " onChange={(event) => this.inputChange(event)} disabled={this.edit ? false : true} />
                                                <label htmlFor="lastname" className="required">Last Name</label>
                                            </div>
                                        </div>
                                        <div className="d-flex">
                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.form.email.error && this.state.form.email.error.length ? <small className="error">{this.state.form.email.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control type="email" id="email" name="email" value={this.state.form.email.value} className={this.state.form.email.value ? 'form-control-active' : ''} placeholder=" " onChange={(event) => this.inputChange(event)} disabled={this.edit ? false : true} />
                                                <label htmlFor="email" className="required">Email</label>
                                            </div>
                                        </div>
                                        {this.edit ?
                                            <div className="d-flex">
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.form.retypeEmail.error && this.state.form.retypeEmail.error.length ? <small className="error">{this.state.form.retypeEmail.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control type="email" id="retypeEmail" name="retypeEmail" value={this.state.form.retypeEmail.value} className={this.state.form.retypeEmail.value ? 'form-control-active' : ''} placeholder=" " onChange={(event) => this.inputChange(event)} onPaste={(event) => event.preventDefault()} autocomplete="off" />
                                                    <label htmlFor="retypeEmail" className="required">Retype Email</label>
                                                </div>
                                            </div> : null
                                        }
                                        <div >
                                            {/* <div className="d-flex" style={{ marginRight: "6%" }}>
                                                <div style={{ marginTop: "15px" }}>
                                                    <Form.Control style={{ height: "38px", paddingLeft: "5px" }} as="select" name="mobileCountryCode" value={this.state.form.mobile.code} onChange={(event) => this.inputChange(event)} disabled={this.edit ? false : true}>
                                                        {this.countryCodeList.map(code =>
                                                            <option key={code.id} value={code.value}>{code.value}</option>
                                                        )}
                                                    </Form.Control>
                                                </div> */}
                                            <div className="float-control mobileClass">
                                                <div className="text">
                                                    {
                                                        this.state.form.mobile.error && this.state.form.mobile.error.length ? <small className="error">{this.state.form.mobile.error}</small> : null
                                                    }
                                                </div>

                                                <Form.Control type="text" id="mobile" name="mobile" value={this.state.form.mobile.value} className={this.state.form.mobile.value ? 'form-control-active' : ''} placeholder=" " onChange={(event) => this.inputChange(event)} disabled={this.edit ? false : true} />
                                                <label htmlFor="mobile" className="required">Mobile</label>
                                            </div>
                                            {/* </div> */}
                                        </div>
                                        <div className="d-flex">
                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.form.roleid.error && this.state.form.roleid.error.length ? <small className="error">{this.state.form.roleid.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control as="select" value={this.state.form.roleid.value} id="roleid" name="roleid" placeholder=" " className={this.state.form.roleid.value ? 'form-control-active' : ''} required onChange={(event) => this.inputChange(event)} disabled={(this.state.userRole === 'Administrator' && !this.edit && this.state.userid !== this.props.user.id) || (this.edit) ? false : true}>
                                                    <option disabled={true} value={""} selected>Select Role</option>
                                                    {this.state.role.map((rolename, index) =>
                                                        <option key={index} value={rolename.id}>{rolename.name}</option>
                                                    )}
                                                </Form.Control>
                                                <label htmlFor="roleid" className="required">Role</label>
                                            </div>
                                        </div>
                                        {!this.edit ?
                                            <div className="d-flex">
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.form.active.error && this.state.form.active.error.length ? <small className="error">{this.state.form.active.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control as="select" id="active" name="active" value={this.state.form.active.value} className={this.state.form.active.value || this.state.form.active.value === 0 ? 'form-control-active' : ''} placeholder=" " required onChange={(event) => this.inputChange(event)} disabled={(this.state.userRole === 'Administrator' && !this.edit && this.state.userid !== this.props.user.id) || (this.edit) ? false : true}>
                                                        <option disabled={true} value={""} selected>Select Status</option>
                                                        <option value={1}>Active</option>
                                                        <option value={0}>Inactive</option>
                                                    </Form.Control>
                                                    <label htmlFor="active" className="required">Status</label>
                                                </div>
                                            </div>
                                            : null
                                        }
                                    </Form>
                                </fieldset>

                                <div>
                                    {this.state.editAccess ?
                                        <div style={{ marginTop: "5%" }} className="mt-4">
                                            <div id="toaster" className={this.state.staffStatus.show ? "d-flex flex-row align-items-center justify-content-center toaster " : ''}>
                                                {
                                                    this.state.staffStatus.show ?
                                                        <ToasterMessage type={this.state.staffStatus.type} message={this.state.staffStatus.message} className="alert-handle"></ToasterMessage>
                                                        : null
                                                }
                                            </div>
                                            <div className="d-flex flex-row justify-content-center">
                                                <Button className="cancel-button btn-white mx-1" onClick={this.navigateToList}>Cancel</Button>
                                                <Button variant="secondary" className="save-button mx-1" style={{ cursor: !this.state.loading ? '' : 'not-allowed' }} disabled={!this.state.loading && ((this.state.userRole === 'Administrator' && !this.edit && this.state.userid !== this.props.user.id) || (this.edit)) && this.state.staffStatus.type !== 'success' ? false : true} onClick={this.checkFieldValidation}>Save {' '} {this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                            </div>
                                        </div> : null
                                    }
                                </div>
                            </div>
                        </Container>
                    </div>
                }

            </div>

        );
    }
}

export default connect(state => state)(StaffAgentsEdit);